import axios from 'axios';
import storage, { storageKey } from 'src/utils/storageUtils';
import { push, replace } from 'connected-react-router';

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(async (config) => {
  const token = storage.get('TOKEN');
  const tenantHash = storage.get('TENANT_HASH');
  if (token && token !== '' && token !== null && typeof token !== 'undefined') {
    config.headers.Authorization = 'Bearer ' + token;
    if (tenantHash) {
      config.headers.Tenant = tenantHash;
    }
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const errData = error?.response?.data || {};
    if (error?.response?.status === 403) {
      storage.del('TOKEN');
      storage.del('TENANT_HASH');
      replace('/auth/login');
    }
    return Promise.reject(errData);
  }
);

export default function api(
  path,
  payload,
  method = 'get',
  isFormData = false,
  onUploadProgress = null,
  responseType = 'json',
  params = {}
) {
  const headers = {};
  if (isFormData) {
    headers['Content-Type'] = 'multipart/form-data';
  }

  return new Promise((resolve, reject) => {
    client
      .request({
        method: method,
        url: path,
        responseType: responseType || 'json',
        data: payload || undefined,
        params: params || undefined,
        ...(Object.keys(headers).length && { headers }),
        ...(onUploadProgress && { onUploadProgress }),
      })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        const errData = error?.response?.data || error?.message || error || {};
        return reject(errData);
      });
  });
}
